import './ui.css';

/**
 * 共用載入狀態。包裝既有旋轉樣式，不另加 spinner asset。
 */
export default function LoadingState({
  label = 'Loading…',
  compact = false,
  className = '',
  ...rest
}) {
  return (
    <div
      className={`ui-loading ${compact ? 'ui-loading--compact' : ''} ${className}`.trim()}
      role="status"
      aria-live="polite"
      {...rest}
    >
      <span className="ui-loading__spinner" aria-hidden="true" />
      {label ? <p className="ui-loading__label">{label}</p> : null}
    </div>
  );
}
